<section class="store-attributes-section" *ngIf="categories$ | async as categories" [formGroup]="attributeFieldsGroup">
  <header class="store-attributes-header">
    <h3 class="store-attributes-title-row">
      <span class="store-attributes-title">Store Attributes</span>
    </h3>
    <p class="store-attributes-subtitle">
      Attributes imported from the store profile data feed. These attributes are inherited by
      associated version codes and used as filter criteria in the Version Search and Offer
      Association workflows.
    </p>
  </header>

  <ng-container *ngIf="categories.length; else noAttributes">
    <div *ngFor="let category of categories" class="attr-section">
      <h4>
        <span class="dot" [style.background-color]="category.colorHex"></span>
        <span [style.color]="category.colorHex">{{ category.name }}</span>
      </h4>

      <div class="attr-grid">
        <ng-container *ngFor="let field of category.fields">
          <ng-container [ngSwitch]="field.valueType">
            <!-- Boolean -->
            <div *ngSwitchCase="booleanType" class="attr-item" [class.attr-item--editable]="!field.sourceField" [class.attr-item--checkbox]="!field.sourceField">
              <ng-container *ngIf="field.sourceField; else editableBoolean">
                <span class="attr-name">{{ field.name }}</span>
                <span class="attr-value" [ngClass]="getValueFlagClass(field)">{{ getDisplayValue(field) }}</span>
              </ng-container>
              <ng-template #editableBoolean>
                <span class="attr-name">{{ field.name }}</span>
                <mat-checkbox class="attr-checkbox" [formControl]="getControl(field.clientKey)"></mat-checkbox>
              </ng-template>
            </div>

            <!-- Text -->
            <div *ngSwitchCase="textType" class="attr-item" [class.attr-item--editable]="!field.sourceField">
              <ng-container *ngIf="field.sourceField; else editableText">
                <span class="attr-name">{{ field.name }}</span>
                <span class="attr-value">{{ getDisplayValue(field) }}</span>
              </ng-container>
              <ng-template #editableText>
                <span class="attr-name">{{ field.name }}</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                  <input matInput type="text" [formControl]="getControl(field.clientKey)" />
                </mat-form-field>
              </ng-template>
            </div>

            <!-- SingleSelect -->
            <div *ngSwitchCase="singleSelectType" class="attr-item" [class.attr-item--editable]="!field.sourceField">
              <ng-container *ngIf="field.sourceField; else editableSingleSelect">
                <span class="attr-name">{{ field.name }}</span>
                <span class="attr-value">{{ getDisplayValue(field) }}</span>
              </ng-container>
              <ng-template #editableSingleSelect>
                <span class="attr-name">{{ field.name }}</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                  <mat-select [formControl]="getControl(field.clientKey)">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let option of field.options" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </div>

            <!-- MultiSelect -->
            <div *ngSwitchCase="multiSelectType" class="attr-item" [class.attr-item--editable]="!field.sourceField">
              <ng-container *ngIf="field.sourceField; else editableMultiSelect">
                <span class="attr-name">{{ field.name }}</span>
                <span class="attr-value">{{ getDisplayValue(field) }}</span>
              </ng-container>
              <ng-template #editableMultiSelect>
                <span class="attr-name">{{ field.name }}</span>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="attr-field">
                  <mat-select [formControl]="getControl(field.clientKey)" multiple>
                    <mat-option *ngFor="let option of field.options" [value]="option">
                      {{ option }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <ng-template #noAttributes>
    <p class="no-attributes-message">No store attribute types configured.</p>
  </ng-template>
</section>
